import RichText from "@/components/RichText";
import { BODY, CONTAINER, SECTION } from "../tokens";

// Bloc particuliers sur fond crème foncé : H2, deux paragraphes, mention
// « Sans rendez-vous · Devis sur place » et la carte de visite scannée,
// encadrée (fond blanc, filet 1px, padding 22px).
export default function ParticuliersSection({ props = {} }) {
  return (
    <section className="bg-sand">
      <div className={`${CONTAINER} ${SECTION} grid gap-10 md:gap-11 [grid-template-columns:repeat(auto-fit,minmax(300px,1fr))]`}>
      <div>
        <RichText
          as="h2"
          className="block font-display font-normal text-[clamp(24px,2.6vw,32px)] leading-[1.25] text-ink mb-[18px]"
          html={props.heading}
        />
        <RichText as="div" preserveParagraphs className={`${BODY} [&_p]:mb-4 [&_p:last-child]:mb-0`} html={props.body} />
        {props.mention && (
          <div className="mt-6 text-[12px] tracking-[0.16em] uppercase text-ash">{props.mention}</div>
        )}
      </div>
      {props.image_url && (
        <div className="bg-white border border-ink/[0.12] p-[22px] self-start">
          <img src={props.image_url} alt={props.alt || ""} className="w-full h-auto block" loading="lazy" />
        </div>
      )}
      </div>
    </section>
  );
}
